import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function SocialMedia() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Name",
      accessorKey: "Name",
     
    },
    {
      header: "Link",
      accessorKey: "Link",
     
    },
   
    {
      header: "Status",
      accessorKey: "total",
      cell: (row) => (<input type="checkbox" className="theme-checkbox"></input>)
    },

    {
      header: "Actions",
      accessorKey: "SN",
      cell: (row) =>
        (<Dropdown />)
    },
  ]);
  const [data] = useState([
    {
      SN: 1,
      Name: "Facebook",
      Link: "	https://www.facebook.com/imdadyposrms",
   
    }
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Social Media"}
      />
    </main>
  );
}

export default SocialMedia ;
